/* eslint-disable react/no-multi-comp */
import { useEffect, useRef, useState } from "react";

import CopyButton from "../CopyButton";

export function CodeBlock(props: React.HTMLProps<HTMLPreElement>) {
  return (
    <pre
      {...props}
      className="not-prose overflow-x-auto rounded border border-gray px-2 py-1.5 font-mono text-xs [&_code]:bg-transparent [&_code]:p-0"
    />
  );
}

export function CodeBlockHeader({ children, ...props }: React.HTMLProps<HTMLElement>) {
  const ref = useRef<HTMLDivElement>(null);

  const [content, setContent] = useState("");

  useEffect(() => {
    setContent(ref.current?.nextElementSibling?.textContent || "");
  }, [ref]);

  return (
    <div
      {...props}
      ref={ref}
      className="flex h-8 items-center gap-1 rounded-t border border-gray bg-slate-100 px-2 [&+pre]:rounded-t-none [&+pre]:border-t-0"
    >
      <span className="text-xs">{children}</span>

      <CopyButton iconOnly={true} contentToCopy={content} className="-mr-1 ml-auto" />
    </div>
  );
}
